"use client";

import Image from "next/image";
import checked from "@/assets/checked.svg";

export default function WeightLossCheckSection() {
  return (
    <div className="flex flex-col md:flex-row gap-8 justify-center max-w-[1440px] mx-auto md:py-20 px-4 sm:px-6 lg:px-20 2xl:px-8">
      {/* Left Section */}
      <div className="flex flex-col justify-center items-start gap-[46px] flex-1 p-[48px_40px_48px_30px] bg-[#F6FAED]">
        <div className="flex flex-col gap-[46px]">
          {/* Heading */}
          <h2 className="text-3xl md:text-4xl w-[80%] text-[#2D3340] font-bold leading-tight">
            Start Your personalised Weight Loss Check
          </h2>

          {/* Feature List */}
          <div className="flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0">
                <Image src={checked} alt="Checked" width={20} height={20} />
              </div>
              <span className="text-gray-900 font-medium">
                Reviewed by our UK-based medical team
              </span>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0">
                <Image src={checked} alt="Checked" width={20} height={20} />
              </div>
              <span className="text-gray-900 font-medium">
                Takes less than 3 minutes to complete
              </span>
            </div>

            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0">
                <Image src={checked} alt="Checked" width={20} height={20} />
              </div>
              <span className="text-gray-900 font-medium">
                Approved treatments dispatched same day (before 3pm)
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex flex-col justify-center items-start gap-[46px] flex-1 p-[56px_36px] bg-[#191F30]">
        <div className="flex flex-col gap-[46px]">
          {/* Heading */}
          <h2 className="text-3xl md:text-4xl font-bold text-white leading-tight">
            Get the medical help you need today.
          </h2>

          {/* Description */}
          <p className="text-white text-lg leading-relaxed">
            Complete a short online assessment to unlock personalised treatment
            choices and select your preferred option and quantity.
          </p>

          {/* CTA Button */}
          <button className="bg-[#7771B8] text-white px-8 py-4 font-semibold text-lg hover:bg-[#6B5B9A] transition-colors">
            Start Weight Loss Check
          </button>
        </div>
      </div>
    </div>
  );
}
